/**
 * contact-form-enhance.js
 * Progressive enhancement for the contact form.
 * The form works without this script — this only adds:
 *  - Loading state on submit (spinner + disable)
 *  - Real-time email validation on blur
 *  - Required GDPR consent check with a visible, localized error
 *  - Double-submit prevention
 */

(function () {
  'use strict';

  var EMAIL_ERROR_ID = 'ContactForm-email-error-js';
  var GDPR_ERROR_ID = 'ContactForm-gdpr-error-js';

  function init() {
    var form = document.getElementById('ContactForm');
    if (!form) return;

    var submitBtn = form.querySelector('.contact-v2__submit');
    var emailInput = document.getElementById('ContactForm-email');
    var gdprInput = document.getElementById('ContactForm-gdpr');
    var submitted = false;

    // ─── Email validation on blur ───
    if (emailInput) {
      emailInput.addEventListener('blur', function () {
        if (emailInput.value && !isValidEmail(emailInput.value)) {
          setEmailError(emailInput);
        } else {
          clearEmailError(emailInput);
        }
      });

      emailInput.addEventListener('input', function () {
        if (isValidEmail(emailInput.value)) clearEmailError(emailInput);
      });
    }

    // ─── GDPR consent: clear the error as soon as the box is ticked ───
    if (gdprInput) {
      gdprInput.addEventListener('change', function () {
        if (gdprInput.checked) clearGdprError(gdprInput);
      });
    }

    // ─── Submit: validation + loading state + double-submit guard ───
    form.addEventListener('submit', function (e) {
      if (submitted) {
        e.preventDefault();
        return;
      }

      var firstInvalid = null;

      if (emailInput && !isValidEmail(emailInput.value)) {
        setEmailError(emailInput);
        firstInvalid = firstInvalid || emailInput;
      }

      if (gdprInput && gdprInput.required && !gdprInput.checked) {
        setGdprError(gdprInput);
        firstInvalid = firstInvalid || gdprInput;
      }

      if (firstInvalid) {
        e.preventDefault();
        firstInvalid.focus();
        return;
      }

      submitted = true;

      if (submitBtn) {
        submitBtn.setAttribute('data-loading', '');
        submitBtn.disabled = true;
      }
    });
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
  }

  function errorMessage(input, fallback) {
    return input.getAttribute('data-error-message') || fallback;
  }

  function createError(id, message) {
    var p = document.createElement('p');
    p.id = id;
    p.className = 'contact-v2__field-error';
    p.setAttribute('role', 'alert');
    p.textContent = message;
    return p;
  }

  function setEmailError(input) {
    input.classList.add('contact-v2__input--error');
    input.setAttribute('aria-invalid', 'true');
    if (!document.getElementById(EMAIL_ERROR_ID)) {
      var p = createError(EMAIL_ERROR_ID, errorMessage(input, 'Please enter a valid email address.'));
      input.parentNode.insertBefore(p, input.nextSibling);
      input.setAttribute('aria-describedby', EMAIL_ERROR_ID);
    }
  }

  function clearEmailError(input) {
    input.classList.remove('contact-v2__input--error');
    input.removeAttribute('aria-invalid');
    var p = document.getElementById(EMAIL_ERROR_ID);
    if (p) {
      p.remove();
      if (input.getAttribute('aria-describedby') === EMAIL_ERROR_ID) input.removeAttribute('aria-describedby');
    }
  }

  function setGdprError(input) {
    var field = input.closest('.contact-v2__field--checkbox');
    if (field) field.classList.add('contact-v2__field--invalid');
    input.setAttribute('aria-invalid', 'true');
    if (!document.getElementById(GDPR_ERROR_ID)) {
      var p = createError(GDPR_ERROR_ID, errorMessage(input, 'Please tick the box to let us contact you about your enquiry.'));
      (field || input.parentNode).appendChild(p);
      input.setAttribute('aria-describedby', GDPR_ERROR_ID);
    }
  }

  function clearGdprError(input) {
    var field = input.closest('.contact-v2__field--checkbox');
    if (field) field.classList.remove('contact-v2__field--invalid');
    input.removeAttribute('aria-invalid');
    var p = document.getElementById(GDPR_ERROR_ID);
    if (p) {
      p.remove();
      if (input.getAttribute('aria-describedby') === GDPR_ERROR_ID) input.removeAttribute('aria-describedby');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
